import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { BsCloudUpload, BsEye, BsFileEarmarkText } from "react-icons/bs";
import { PrimaryButton, SecondaryButton } from "../../StyledCss/styledbtn";
// import { AiFillDelete } from "react-icons/ai";
import "./index.css";
// import UploadingLoader from "../UploadingLoader";
import { HiOutlinePencil } from "react-icons/hi2";
import { DetailsText, DetailsTextLabel } from "../../StyledCss/styledCss";
import DocumentPreviewModal from "../DocumentPreviewModal";
import {
  // deleteProfilePicture,
  getProfile,
  updateEmployee,
} from "../../api/services/hroneApi";
import formatDate from "../../util/formatdate";
import { usePermissions } from "../../redux/slices/permissionsSlice";
import { FEATURE_CODES } from "../../util/featureCodes";

import { TabHeading } from "../../StyledCss/styledCss";
import {
  StyledInput,
  StyledInputContainer,
  StyledInputGroup,
  StyledLabel,
  StyledSelect,
  StyledSelectContainer,
  StyledSelectGroup,
} from "../../StyledCss/styledInputs";
const apiStatusConstants = {
  initial: "INITIAL",
  success: "SUCCESS",
  failure: "FAILURE",
  inProgress: "IN_PROGRESS",
};

const AADHAR_INPUT_ID = "personal-info-aadhar-upload";
const PAN_INPUT_ID = "personal-info-pan-upload";
const MAX_FILE_SIZE_BYTES = 1 * 1024 * 1024;

const Pinfo = ({ refreshPage }) => {
  const { hasPermission } = usePermissions();
  const canEditProfile = hasPermission(FEATURE_CODES.PROFILE_EDIT);
  const [employeeData, setEmployeeData] = useState({});
  const [apiStatus, setApiStatus] = useState(apiStatusConstants.initial);
  const [editProfile, setEditProfile] = useState(false);
  const [previewDoc, setPreviewDoc] = useState(null);
  const [aadharFile, setAadharFile] = useState(null);
  const [panFile, setPanFile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);


  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  useEffect(() => {
    getUserDetails();
    // eslint-disable-next-line
  }, []);

  const pickFile = (inputId) => document.getElementById(inputId)?.click();

  // Aadhar/PAN are just picked here and held in state — they aren't sent to the
  // backend until the main "Submit" button is pressed, same as every other field.
  const stageFile = (e, setFile) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    const ext = file.name.split(".").pop()?.toLowerCase();
    if (ext !== "pdf" || file.type !== "application/pdf") {
      toast.error("Only PDF files are allowed");
      return;
    }
    if (file.size > MAX_FILE_SIZE_BYTES) {
      toast.error("File size should not exceed 1MB");
      return;
    }
    setFile(file);
  };

  const getUserDetails = async () => {
    setApiStatus(apiStatusConstants.inProgress);
    try {
      const response = await getProfile();
      if (response.status === 200) {
        const data = await response.json();
        const updatedData = {
          id: data.id,
          firstName: data.first_name,
          lastName: data.last_name,
          dob: data.date_of_birth,
          qualifications: data.qualifications,
          department: data.department,
          bloodGroup: data.blood_group,
          gender: data.gender,
          mobileNo: data.mobile_number,
          email: data.email,
          location: data.address,
          designation: data.designation,
          joiningDate: data.joining_date,
          role: data.role,
          address: data.address,
          emergencyContactName: data.emergency_contact_name,
          emergencyContactNumber: data.emergency_contact_number,
          profilePicUrl: data.profile_picture_url,
          aadharCardUrl: data.aadhar_card_url,
          panCardUrl: data.pan_card_url,
        };

        // setProfilePicUrl(data.profile_picture_url);

        setEmployeeData(updatedData);
        setApiStatus(apiStatusConstants.success);
      } else {
        setApiStatus(apiStatusConstants.failure);
      }
    } catch (e) {
      setApiStatus(apiStatusConstants.failure);
    }
  };

  const ProfileInfoSection = () => (
    <div className="personal-info-grid">
      <div>
        <DetailsTextLabel>Full Name</DetailsTextLabel>
        <DetailsText>
          {employeeData.firstName} {employeeData.lastName}
        </DetailsText>
      </div>
      <div>
        <DetailsTextLabel>Gender</DetailsTextLabel>
        <DetailsText>{employeeData.gender}</DetailsText>
      </div>
      <div>
        <DetailsTextLabel>Aadhar Card</DetailsTextLabel>
        <div className="kyc-doc-row">
          <div className="kyc-doc-box">
            <BsFileEarmarkText size={14} className="kyc-doc-file-icon" />
            <span className={employeeData.aadharCardUrl ? "kyc-doc-status-text kyc-doc-status-text--uploaded" : "kyc-doc-status-text"}>
              {employeeData.aadharCardUrl ? "Uploaded Successfully" : "Not Uploaded"}
            </span>
          </div>
          <button
            type="button"
            className="kyc-icon-btn"
            disabled={!employeeData.aadharCardUrl}
            title="View"
            onClick={() => setPreviewDoc({ title: "Aadhar Card", url: employeeData.aadharCardUrl })}
          >
            <BsEye size={15} />
          </button>
        </div>
      </div>

      <div>
        <DetailsTextLabel>Date Of Birth</DetailsTextLabel>
        <DetailsText>{formatDate(employeeData.dob)}</DetailsText>
      </div>
      <div>
        <DetailsTextLabel>Phone Number</DetailsTextLabel>
        <DetailsText>{employeeData.mobileNo}</DetailsText>
      </div>
      <div>
        <DetailsTextLabel>PAN Card</DetailsTextLabel>
        <div className="kyc-doc-row">
          <div className="kyc-doc-box">
            <BsFileEarmarkText size={14} className="kyc-doc-file-icon" />
            <span className={employeeData.panCardUrl ? "kyc-doc-status-text kyc-doc-status-text--uploaded" : "kyc-doc-status-text"}>
              {employeeData.panCardUrl ? "Uploaded Successfully" : "Not Uploaded"}
            </span>
          </div>
          <button
            type="button"
            className="kyc-icon-btn"
            disabled={!employeeData.panCardUrl}
            title="View"
            onClick={() => setPreviewDoc({ title: "PAN Card", url: employeeData.panCardUrl })}
          >
            <BsEye size={15} />
          </button>
        </div>
      </div>

      <div>
        <DetailsTextLabel>Blood Group</DetailsTextLabel>
        <DetailsText>{employeeData.bloodGroup}</DetailsText>
      </div>

      <div>
        <DetailsTextLabel>Address</DetailsTextLabel>
        <DetailsText>{employeeData.address}</DetailsText>
      </div>

      <TabHeading style={{ fontSize: "14px" }}>Emergency Details</TabHeading>
      <div>
        <DetailsTextLabel>Contact Name</DetailsTextLabel>
        <DetailsText>{employeeData.emergencyContactName}</DetailsText>
      </div>

      <div>
        <DetailsTextLabel>Contact Number</DetailsTextLabel>
        <DetailsText>{employeeData.emergencyContactNumber}</DetailsText>
      </div>
    </div>
  );

  const onSubmit = (data) => {
    onClickSubmitChanges(data);
  };

  const onClickSubmitChanges = async (data) => {
    setIsSubmitting(true);
    try {
      const response = await updateEmployee(data, { aadharFile, panFile });
      if (response.ok) {
        setEditProfile(false);
        setAadharFile(null);
        setPanFile(null);
        toast.success("Details Updated Successfully");
        getUserDetails();
      } else {
        const body = await response.json();
        toast.error(body.detail || "Something Went Wrong");
      }
    } catch (error) {
      toast.error("Something Went Wrong");
    } finally {
      setIsSubmitting(false);
    }
  };


  const editProfileSection = () => (
    <div className="edit-profile-info-container d-flex ">
      <div className="edit-account-details">{EditProfileForm()}</div>
    </div>
  );

  const AadharPanEditCell = ({ label, url, inputId, stagedFile }) => (
    <StyledInputGroup>
      <StyledInputContainer>
        <div className="kyc-doc-row">
          <div className="kyc-doc-box">
            <BsFileEarmarkText size={14} className="kyc-doc-file-icon" />
            <span className={(stagedFile || url) ? "kyc-doc-status-text kyc-doc-status-text--uploaded" : "kyc-doc-status-text"}>
              {stagedFile ? stagedFile.name : url ? "Uploaded Successfully" : "Not Uploaded"}
            </span>
          </div>
          <button
            type="button"
            className="kyc-icon-btn"
            disabled={!url}
            title="View"
            onClick={() => setPreviewDoc({ title: label, url })}
          >
            <BsEye size={15} />
          </button>
          <input
            id={inputId}
            type="file"
            accept=".pdf"
            style={{ display: "none" }}
            onChange={(e) => stageFile(e, inputId === AADHAR_INPUT_ID ? setAadharFile : setPanFile)}
          />
          <button
            type="button"
            className="kyc-icon-btn"
            title={url ? "Replace" : "Upload"}
            onClick={() => pickFile(inputId)}
          >
            <BsCloudUpload size={15} />
          </button>
        </div>
        <StyledLabel hasValue className="user-label">{label}</StyledLabel>
      </StyledInputContainer>
    </StyledInputGroup>
  );

  const EditProfileForm = () => (
    <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
      <div className="personal-info-edit-grid">

        <StyledInputGroup>
          <StyledInputContainer>
            <StyledInput
              style={errors.dob && { borderLeft: "10px solid red" }}
              inputError={errors.dob}
              defaultValue={employeeData.dob}
              {...register("dob", { required: true })}
              type="date"
            />
            <StyledLabel className="user-label">DOB*</StyledLabel>
          </StyledInputContainer>
        </StyledInputGroup>

        <StyledInputGroup>
          <StyledInputContainer>
            <StyledInput
              style={errors.mobileNumber && { borderLeft: "10px solid red" }}
              inputError={errors.mobileNumber}
              defaultValue={employeeData.mobileNo}
              {...register("mobileNumber", {
                required: true,
                maxLength: 10,
                pattern: /[0-9]{10}/,
              })}
              type="tel"
            />
            <StyledLabel className="user-label">Mobile No*</StyledLabel>
          </StyledInputContainer>
        </StyledInputGroup>

        <AadharPanEditCell
          label="Aadhar Card"
          url={employeeData.aadharCardUrl}
          inputId={AADHAR_INPUT_ID}
          stagedFile={aadharFile}
        />

        <StyledSelectGroup>
          <StyledSelectContainer>
            <StyledSelect
              style={errors.bloodGroup && { borderLeft: "10px solid red" }}
              defaultValue={employeeData.bloodGroup}
              required
              name="select"
              {...register("bloodGroup", { required: true })}
            >
              <option className="option-bg" value="A+">
                A+
              </option>
              <option value="B+">B+</option>
              <option value="AB+">AB+</option>
              <option value="O+">O+</option>
              <option value="A-">A-</option>
              <option value="B-">B-</option>
              <option value="AB-">AB-</option>
              <option value="O-">O-</option>
            </StyledSelect>
            <StyledLabel className="user-label">Blood Group</StyledLabel>
          </StyledSelectContainer>
        </StyledSelectGroup>

        <StyledInputGroup>
          <StyledInputContainer>
            <StyledInput
              style={errors.location && { borderLeft: "10px solid red" }}
              defaultValue={employeeData.location}
              {...register("location", {
                required: true,
                pattern: /^[A-Za-z]{3,20}/i,
              })}
              type="text"
            />
            <StyledLabel className="user-label">Location*</StyledLabel>
          </StyledInputContainer>
        </StyledInputGroup>

        <AadharPanEditCell
          label="PAN Card"
          url={employeeData.panCardUrl}
          inputId={PAN_INPUT_ID}
          stagedFile={panFile}
        />

        <StyledInputGroup>
          <StyledInputContainer>
            <StyledInput
              style={
                errors.emergencycontactName && { borderLeft: "10px solid red" }
              }
              defaultValue={employeeData.emergencyContactName}
              {...register("emergencycontactName", {
                required: true,
                pattern: /^[A-Za-z]{3,10}/,
              })}
              type="text"
            />
            <StyledLabel className="user-label">
              Emergency Contact Name*
            </StyledLabel>
          </StyledInputContainer>
        </StyledInputGroup>

        <StyledInputGroup>
          <StyledInputContainer>
            <StyledInput
              style={
                errors.emergencyContactNumber && {
                  borderLeft: "10px solid red",
                }
              }
              defaultValue={employeeData.emergencyContactNumber}
              {...register("emergencyContactNumber", {
                required: true,
                maxLength: 10,
                pattern: /[0-9]{10}/,
              })}
              type="tel"
            />
            <StyledLabel className="user-label">
              Emergency Contact No*
            </StyledLabel>
          </StyledInputContainer>
        </StyledInputGroup>
      </div>

      <div className="d-flex justify-content-end gap-3">
        <SecondaryButton
          type="button"
          onClick={() => {
            setEditProfile(false);
            setAadharFile(null);
            setPanFile(null);
            reset();
          }}
        >
          Cancel
        </SecondaryButton>

        <PrimaryButton type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Submitting..." : "Submit"}
        </PrimaryButton>
      </div>
    </form>
  );

  const renderProfile = () => {
    switch (apiStatus) {
      case apiStatusConstants.inProgress:
        return (
          <div className="d-flex justify-content-center w-100">
            <div className="spinner-border text-primary " role="status"></div>
          </div>
        );
      case apiStatusConstants.success:
        return ProfileInfoSection();
      case apiStatusConstants.failure:
        return null;
      default:
        return null;
    }
  };

  const onClickEditProfile = () => {
    setEditProfile(!editProfile);
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center" style={{ marginBottom: 18 }}>
        <TabHeading>Personal Info</TabHeading>
        {canEditProfile && (
          <button onClick={onClickEditProfile} className="editIcon" type="button">
            <HiOutlinePencil size={20} />
          </button>
        )}
      </div>
      {editProfile && canEditProfile ? editProfileSection() : renderProfile()}

      {previewDoc && (
        <DocumentPreviewModal
          title={previewDoc.title}
          url={previewDoc.url}
          onClose={() => setPreviewDoc(null)}
        />
      )}

    </div>
  );
};

export default Pinfo;